/**
 * SchematicGenerator/utils.js — shared helpers extracted from
 * SchematicGeneratorPanel.jsx (P3 refactor v2.55).
 */
import { api } from "@/lib/api";

export const ALLOWED_EXTS = /\.(csv|dwg|dxf)$/i;

export async function getBlob(path) {
  const r = await api.get(path, { responseType: "blob" });
  return r.data;
}

export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
